import Joi from 'joi-browser'

const queue = Joi.object().keys({
	id: Joi.number().integer().positive(),
	tenantId: Joi.string().uuid(),
	queueName: Joi.string().max(100).required(),
	description: Joi.string().max(255),
	groupApprovers: Joi.array().allow('', null),
	//group_approvers : Joi.string().allow('',null),
	conditionName: Joi.string().required(),
	priority: Joi.number().integer(),
	slaGoals: Joi.string().allow(null),
	responseSlaGoals: Joi.string().allow(null),
	calendar: Joi.string().allow(null),
	whenObj: Joi.any(),
	classifier: Joi.any(),
	bpmQueueRef: Joi.string().required(),
	status: Joi.string().valid('Published', 'Draft', 'Deleted').default('Draft'),
	updatedBy: Joi.string().allow('', null),
	updatedAt: Joi.date().allow('', null),
	createdBy: Joi.string().allow('', null),
	createdAt: Joi.date().allow('', null),
	deletedSeq: Joi.number().integer().allow('', null),
	queueType: Joi.string().optional().allow('', null),
	properties: Joi.object()
		.keys({
			emailAddress: Joi.string().optional().allow('', null),
			replyTo: Joi.string().optional().allow('', null),
			queueLabel: Joi.string().optional().allow('', null),
			isDraftDelete: Joi.bool().optional().allow('', null),
			agentConfig:Joi.string().optional().allow('', null),
			customerAgents: Joi.array().allow('', null),
		})
		.allow('', null),
	lookupProps: Joi.object().keys({
		usecase: Joi.string().required(),
		clientApp: Joi.string().required().valid('tickets', 'approvals'),
		itemType: Joi.string().optional().allow('', null),
	}),
	teamId: Joi.string().optional().allow('', null),
})
// These are the schemas of the return object from the api server
export const methodSchemas = {
	getAll: Joi.array().items(queue),
	getOne: queue,
	addItem: queue,
	deleteItem: Joi.object().keys({ id: Joi.number().integer().positive() }),
	editItem: queue,
}
export const collectionSchemas = {
	//  notes: note
}
export const entitySchema = queue
